export default __webpack_public_path__ + "static/media/bell.72657333.svg";